export default __webpack_public_path__ + "assets/images/configuracoesc70f808bb9a19b16525277c15dd130f1.png";